import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Karyawan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Karyawan',
        href: '/adm/karyawan',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_karyawan',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'kode_karyawan',
        label: 'NIK',
        sortable: true,
      },
      {
        key: 'nm_karyawan',
        label: 'Nama Karyawan',
      },
      {
        key: 'telp',
        label: 'Telp',
      },
      {
        key: 'user_name',
        label: 'User Name',
      },
      {
        key: 'total_cuti',
        label: 'Sisa Cuti',
      },
      {
        key: 'nm_dept',
        label: 'Dept',
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
      },
      {
        key: 'status_karyawan',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeKaryawan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchKaryawan(context, params = null) {
    let result = await ApiGetRequest(`karyawan`, params);
    return !result.error ? result.data.object : [];
  },

  async getListKaryawan({ commit, state }, payload = {}) {
    commit('changeKaryawan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`karyawan`, params);
      commit('changeKaryawan', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_karyawan.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeKaryawan', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await ApiGetRequest(`karyawan`, params);
      commit('changeKaryawan', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailKaryawan({ commit }, payload = null) {
    commit('changeKaryawan', {
      loading: true,
    });

    let result = await ApiGetRequest(`karyawan/${payload.id}`);
    commit('changeKaryawan', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadLogoKaryawan({ commit, state }, payload) {
    commit('changeKaryawan', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeKaryawan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKaryawan', {
        form: {
          ...data.form,
          foto: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeKaryawan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`karyawan/import`, {
      items: data.import_form || [],
    });

    commit('changeKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createKaryawan({ commit, state, dispatch }) {
    commit('changeKaryawan', {
      loading: true,
    });

    let result = await ApiPostRequest(`karyawan`, state.data.form);
    commit('changeKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateKaryawan({ commit, state, dispatch }, payload = null) {
    commit('changeKaryawan', {
      loading: true,
    });

    let result = await ApiPutRequest(`karyawan/${payload.id}`, state.data.form);

    commit('changeKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteKaryawan({ commit, dispatch }, payload = null) {
    commit('changeKaryawan', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`karyawan/${payload.id}`);
    commit('changeKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
